import { ReactNode, createContext, useEffect } from 'react'
import { triggerGoogleTagManagerEvent } from './event'
import { getPageLocation } from '../routes'

interface AnalyticsProviderProps {
  children: ReactNode
}

export const AnalyticsContext = createContext({})

export const AnalyticsContextProvider = ({
  children,
}: AnalyticsProviderProps) => {
  // Trigger page view event on page load
  useEffect(() => {
    triggerGoogleTagManagerEvent('page_view', {
      page_title: document.title,
      page_location: getPageLocation(),
      page_referrer: document.referrer,
    })
  }, [])

  return (
    <AnalyticsContext.Provider value={{}}>{children}</AnalyticsContext.Provider>
  )
}
